var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.type + ' btn' + (_vm.disable? ' a_disabled': ''),on:{"click":_vm.clickBtn}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }